<div class="dialog-wrapper" @expand>
  <form #enquiryForm="ngForm" (ngSubmit)="submit(enquiryForm)" novalidate>

    <!-- Header -->
    <div class="header">
      <h2 mat-dialog-title class="title">
        <mat-icon color="primary">support_agent</mat-icon>
        School Enquiry
      </h2>

      <button
        mat-icon-button
        type="button"
        class="close-btn"
        aria-label="Close dialog"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="content">

<div class="full enquiry-type">

  <label class="mat-body-1 enquiry-label">
    Enquiry Type <span class="text-danger">*</span>
  </label>

  <mat-radio-group
    name="enquiryType"
    [(ngModel)]="model.enquryType"
    required
    #enquiryType="ngModel"
    class="radio-group">

    <mat-radio-button
      *ngFor="let type of enquiryTypeKeys; trackBy: trackByFn"
      [value]="enquiryTypes[type]">
      {{ type }}
    </mat-radio-button>
  </mat-radio-group>

  <mat-error *ngIf="enquiryType.invalid && enquiryType.touched">
    Enquiry type is required
  </mat-error>

</div>


      <!-- Admission Class -->
      <mat-form-field
        *ngIf="model.enquryType === enquiryTypes.Admission"
        appearance="outline"
        class="full"
        floatLabel="always">

        <mat-label>Class</mat-label>

        <mat-select
          name="admissionClass"
          [(ngModel)]="model.admissionClass"
          [required]="model.enquryType === enquiryTypes.Admission"
          #admissionClass="ngModel"
          placeholder="Select class">

          <mat-option *ngFor="let cls of classOptions" [value]="cls">
            {{ cls }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="admissionClass.invalid && admissionClass.touched">
          Class is required for admission enquiry
        </mat-error>
      </mat-form-field>

      <!-- Personal Info -->
      <div class="grid">

        <!-- Full Name -->
        <mat-form-field appearance="outline" floatLabel="always" hideRequiredMarker>
          <mat-label><span class="text-danger">*</span> Full Name</mat-label>

          <input
            matInput
            name="visitorName"
            [(ngModel)]="model.visitorName"
            required
            maxlength="60"
            pattern="^[a-zA-Z ]+$"
            placeholder="Enter full name"
            autocomplete="name"
            #visitorName="ngModel" />

          <mat-hint align="end">
            {{ model.visitorName.length || 0 }}/60
          </mat-hint>

          <mat-error *ngIf="visitorName.errors?.['required']">
            Full name is required
          </mat-error>

          <mat-error *ngIf="visitorName.errors?.['pattern']">
            Only letters and spaces are allowed
          </mat-error>
        </mat-form-field>

        <!-- Email -->
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Email</mat-label>

          <input
            matInput
            name="emailId"
            [(ngModel)]="model.emailId"
            email
            placeholder="example@email.com"
            autocomplete="email"
            #emailId="ngModel" />

          <mat-error *ngIf="emailId.invalid && emailId.touched">
            Enter a valid email address
          </mat-error>
        </mat-form-field>

      </div>

      <div class="grid">

        <!-- Phone -->
        <mat-form-field appearance="outline" floatLabel="always" hideRequiredMarker>
          <mat-label><span class="text-danger">*</span> Phone Number</mat-label>

          <input
            matInput
            type="tel"
            name="phoneNo"
            [(ngModel)]="model.phoneNo"
            required
            pattern="[0-9]{10}"
            minlength="10"
            maxlength="10"
            placeholder="10-digit mobile number"
            inputmode="numeric"
            autocomplete="tel"
            #phoneNo="ngModel" />

          <mat-error *ngIf="phoneNo.errors?.['required'] && phoneNo.touched">
            Phone number is required
          </mat-error>

          <mat-error *ngIf="phoneNo.errors?.['pattern'] && phoneNo.touched">
            Enter a valid 10-digit phone number
          </mat-error>
        </mat-form-field>

        <!-- Town -->
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Town</mat-label>

          <input
            matInput
            name="town"
            [(ngModel)]="model.address.town"
            placeholder="Enter town / city"
          />
        </mat-form-field>

      </div>

      <!-- Message -->
      <mat-form-field appearance="outline" class="full" floatLabel="always">
        <mat-label>Message</mat-label>

        <textarea
          matInput
          name="remarks"
          rows="3"
          [(ngModel)]="model.remarks"
          maxlength="250"
          placeholder="Write your message"
          #remarks="ngModel">
        </textarea>

        <mat-hint align="end">
          {{ model.remarks.length || 0 }}/250
        </mat-hint>

      </mat-form-field>

    </div>

    <!-- Actions -->
    <div class="actions">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="loading || enquiryForm.invalid">

        <mat-spinner
          *ngIf="loading"
          diameter="18"
          class="btn-spinner">
        </mat-spinner>

        <span *ngIf="!loading">Submit Enquiry</span>
      </button>
    </div>

  </form>
</div>
